// extracted by mini-css-extract-plugin
module.exports = {"container":"success_container__DieVE","card":"success_card__31p1k","row":"success_row__2kQ9K","back":"success_back__o4WWk"};